import { render, staticRenderFns } from "./float.global.vue?vue&type=template&id=6145320e&"
import script from "./float.global.vue?vue&type=script&lang=js&"
export * from "./float.global.vue?vue&type=script&lang=js&"
import style0 from "./float.global.vue?vue&type=style&index=0&id=6145320e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports